import cbo from '../../../../Assets/CBO2002 - Ocupacao.json';

interface Profissao {
  code: string;
  name: string;
}

export const opcoesProfissao = (cbo as Profissao[]).sort((a, b) => a.name.localeCompare(b.name, "pt-BR")).map((profissao) => profissao.name);
